angular.module('liveScoreFirebaseService', [])
    .factory('liveScoreFirebaseService', ['$q', function ($q) {
        let databaseUrl;
        let gameRef;

        // this can be really helpful when you're stuck.
        // firebase.database.enableLogging(true);

        let authenticate = function (fbDatabase, fbApiKey, fbJwt) {
            let deferred = $q.defer();

            databaseUrl = fbDatabase;
            firebase.initializeApp({
                apiKey: fbApiKey,
                databaseURL: fbDatabase
            });

            // Existing and future Auth states are now persisted in the current session
            // only. Closing the window would clear any existing state even if a user
            // forgets to sign out. New sign-in will be persisted with session persistence.
            firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION).then(function () {
                // Once I have the 'token', the clientside JS authenticates here...
                return firebase.auth().signInWithCustomToken(fbJwt).then(function () {
                    deferred.resolve();
                }).catch(function (error) {
                    // Handle Errors here.
                    var errorCode = error.code;
                    var errorMessage = error.message;
                    console.warn("ERROR: Firebase failed to authenticate", errorCode, errorMessage);
                });
            }).catch(function (error) {
                // Handle Errors here.
                var errorCode = error.code;
                var errorMessage = error.message;
                console.warn("ERROR: Firebase failed to authenticate", errorCode, errorMessage);
            });

            return deferred.promise;
        };

        let signOut = function () {
            return firebase.auth().signOut();
        }

        let getGameRef = function (gameId) {
            if (!databaseUrl) console.warn("ERROR: database url is undefined in firebaseRef::getGameRef");
            if (!gameId) console.warn("ERROR: gameId is undefined in firebaseRef::getGameRef");
            if (!databaseUrl || !gameId) {
                return;
            }

            gameRef = firebase.database().ref().child("/game/" + gameId);

            return gameRef;
        };

        // Sets the owner property of the game node
        let setOwner = function (ownerUid) {
            gameRef.child('owner').set(ownerUid);
        }

        // Sets the running property of the game node
        let setRunning = function (isRunning) {
            gameRef.child('running').set(isRunning);
        };

        // Sets the time property of the game node
        let setTime = function (time) {
            gameRef.child('time').set(time);
        };

        // Sets the useLiveScoring property of the game node
        let setUseLiveScore = function (useLiveScore) {
            gameRef.child('useLiveScoring').set(useLiveScore);
        };

        // Will update the game node with whatever data is passed in
        let update = function (scoreboardData) {
            gameRef.update(scoreboardData);
        };

        return {
            authenticate: authenticate,
            signOut: signOut,
            getGameRef: getGameRef,
            setOwner: setOwner,
            setRunning: setRunning,
            setTime: setTime,
            setUseLiveScore: setUseLiveScore,
            update: update
        };
    }]);



// WEBPACK FOOTER //
// ./app.v2/components/admin/broadcastManager/liveScoreFirebaseService.js